export default "__VITE_ASSET__Ckmo50v$__"